import { createContext, useContext, useState } from "react";

const WaitlistContext = createContext();

export function WaitlistProvider({ children }) {
  const [isOpen, setIsOpen] = useState(false);

  const openModal = () => {
    sessionStorage.setItem("flavrd_popup_shown", "1");
    setIsOpen(true);
  };

  return (
    <WaitlistContext.Provider value={{ isOpen, openModal, closeModal: () => setIsOpen(false) }}>
      {children}
    </WaitlistContext.Provider>
  );
}

export function useWaitlist() {
  return useContext(WaitlistContext);
}
